import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";
import { ConnectionHandler } from "relay-runtime";

const mutation = graphql`
	mutation AddNoteMutation($input: AddNoteInput!) {
		addNote(input: $input) {
			noteEdge {
				cursor
				node {
					id
					note
					date_saved
					isNote
				}
			}
		}
	}
`;

// let folderName = "x Empty";

function sharedUpdater(store, noteEdge) {

	const userProxy = store.get(localStorage.getItem(GC_USER_ID));
	const connection = ConnectionHandler.getConnection(userProxy, "NoteView_notes");
	if (connection) {
		ConnectionHandler.insertEdgeBefore(connection, noteEdge);
	}
}

let nextClientMutationId = 0;
export default (postId, note, callback) => {
	const clientMutationId = (nextClientMutationId++).toString();
	const variables = {
		input: {
			postId: postId,
			note: note
		}
	};

	commitMutation(environment, {
		mutation,
		variables,

		updater(store) {
			const payload = store.getRootField("addNote");
			sharedUpdater(store, payload.getLinkedRecord("noteEdge"));
		},

		optimisticUpdater(store) {
			const id = `client:addNote:Note:${clientMutationId}`;
			const newNote = store.create(id, 'Note');
			newNote.setValue(note, 'note');
			newNote.setValue(id, 'id');
			const noteEdge = store.create(
				`client:addNote:noteEdge:${clientMutationId}`,
				'noteEdge'
			);
			noteEdge.setLinkedRecord(newNote, 'node');
			sharedUpdater(store, noteEdge);
		},

		onCompleted: (response, errors) => {
			if (response.addNote != null) {
				callback();
			} else {
				console.log("Unable to create new Note!");
			}
		},
		onError: err => console.error(err)
	});
};
